export class DisplayWindow {
  public start: string;
  public end: string;

  constructor(
    start: string,
    end: string
  ) {
    this.start = start;
    this.end = end;
  }

  public calculateSecondsPerTenPixels() : number | undefined {
    if (this.start === undefined || this.end === undefined) {
      return;
    }

    // Note: the best approach is to use a predefined amount of pixels per data point
    const timeInSeconds = Math.round(Math.abs(new Date(this.end).getTime() - new Date(this.start).getTime())) / 1000;
    const scaleFactor = timeInSeconds / 3600 <= 12 ? 2000 : 1000;
    return Math.round(timeInSeconds / scaleFactor);
  }
}
